// extracted by mini-css-extract-plugin
export default {"container":"InvestigationNotes_container__cMNYE"};